export default {
  id: 'expansion',
  instructionInfo: [
    '链下扩容是一种解决区块链扩容问题的方法，通过将一些计算或交易操作从区块链上移出来，以减轻链上的负担。例如在高频交易这个场景下，链下扩容就能发挥很大的作用，当交易非常多，链上交易已经不足以支撑这么多交易，链下扩容功能就可以将一些交易操作从链上移至链下进行处理。只在必要时将结果上链，从而快速提高交易吞吐量和响应速度。'
  ]
}
